module.exports = __webpack_public_path__ + "static/media/internet-marketing-1802610_1280.dc816351.png";